import type { RezaOpravneniDto } from '@gov-nx/api';
import { useRezaEligibleList, useRobPersonQuery } from '@gov-nx/core/hooks';
import { useConfiguration } from '@gov-nx/core/service';
import { is } from '@gov-nx/core/types';
import { useAuthStore } from '@gov-nx/store';

export const useRecentReza = () => {
	const { allowedRezaTemplates } = useConfiguration();

	const query = useRezaEligibleList({
		params: {
			role: 'zmocnenec',
		},
		filter: {
			typ: 'implicitni',
			kodSablony: allowedRezaTemplates?.split(',').map((code) => code.trim()),
		},
	});
	const rezaHistory = useAuthStore('rezaHistory');

	const personQuery = useRobPersonQuery();

	const me: RezaOpravneniDto | null = personQuery.data
		? {
				kod: '',
				zastupujiciOsoba: {
					fyzickaOsoba: {
						jmeno: personQuery.data?.jmeno,
						prijmeni: personQuery.data?.prijmeni,
						datumNarozeni: personQuery.data?.datumNarozeni,
						adresa: personQuery.data?.adresaPobytu,
					},
				},
				zastupujiciOsobaTyp: 'FO',
			}
		: null;

	const identityList = [me, ...(query.data?.seznam ?? [])].filter(
		is
	) as RezaOpravneniDto[];

	const sortedList = identityList.sort((a, b) => {
		const aIdx = rezaHistory.indexOf(a.kod ?? '');
		const bIdx = rezaHistory.indexOf(b.kod ?? '');
		if (aIdx === -1 && bIdx === -1) return 0; // both not in history, keep order
		if (aIdx === -1) return 1; // a not in history, push back
		if (bIdx === -1) return -1; // b not in history, push back
		return aIdx - bIdx; // both in history, sort by history order
	});

	return {
		hasNoReza: query.data ? query.data.pocet === 0 : false,
		data: sortedList,
		meAsReza: me,
		isLoading: query.isLoading || personQuery.isLoading,
		error: { rezaError: query.error, personError: personQuery.error },
	};
};
